export {
  PracticumLogo,
  PracticumGroupLogo,
  PracticumGroupLogoMark,
  PracticumGroupLogoStar,
} from "./PracticumLogos";
